module.exports = __webpack_public_path__ + "static/media/un_fao.788ab643.png";